import { Shippo } from 'shippo';
import toast from 'react-hot-toast';

const minimumRate = rates => rates.reduce((min, current) => Number(current.amount) < Number(min.amount) ? current : min);

export const createShipmentAndLabel = async (addressFrom, addressTo, parcel) => {
    try {
        const shippo = new Shippo({apiKeyHeader: process.env.REACT_APP_SHIPPO_API_KEY});
        let shipment;

        if (addressTo.country === 'US') {
            shipment = await shippo.shipments.create({
                addressFrom,
                addressTo,
                parcels: [parcel],
                carrierAccounts: ['c50417157c9b4de4966caa0c9f1901db'],
                async: false,
            });
        }

        if (shipment.messages.length > 0) {
            shipment.messages.forEach((message) => {
                toast.error(message.text);
            })
        }

        if (shipment.rates.length > 0) {
            const selectedRate = await minimumRate(shipment.rates);
            const labelResult = await shippo.transactions.create({
                rate: selectedRate?.objectId,
                labelFileType: "PDF_4x6",
                metadata: "Order ID #12345", // TODO Update
                async: false
            });

            return labelResult;
        }

    } catch (error) {
        toast.error(error);
    }
}